var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.expanded)?_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._t("header")],2),_c('v-expansion-panel-content',{staticClass:"mx-0 py-0"},[_vm._t("default")],2)],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }